import ListValidations from './views/List.vue'
import CreateEditValidation from './views/CreateEdit.vue'
import GetValidation from './views/Get.vue'

export const ValidationRoutes = [
  {
    path: '/validations',
    name: 'ListValidations',
    component: ListValidations,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'validation:list'
    }
  },
  {
    path: '/validation',
    name: 'CreateValidation',
    component: CreateEditValidation,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'validation:create'
    }
  },
  {
    path: '/validation/:id',
    name: 'UpdateValidation',
    component: CreateEditValidation,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'validation:update'
    }
  },
  {
    path: '/validation/view/:id',
    name: 'GetValidation',
    component: GetValidation,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'validation:get'
    }
  }
]
